import Cookie from "../utils/cookie";

const $ = window.jQuery;
const $window = window.$window || $(window);
const $document = window.$document || $(document);
import throttle from "../utils/throttle";

const NewsletterPopup = {

    $popup: null,

    init() {
        var $placeholder = $('#NewsletterPopupPlaceholder');
        if (!$placeholder.length) {
            return;
        }

        if (this.user_has_dismissed()) {
            return;
        }

        this.fetch_markup().then((data) => {
            if (data.hasOwnProperty('markup')) {
                this.$popup = $(data.markup);
                $placeholder.replaceWith(this.$popup);
                this.init_dynamic_component();
            }
        });

    },

    user_has_dismissed() {
        return !!Cookie.get('hktnsubpop');
    },

    set_hide_cookie() {
        Cookie.set('hktnsubpop', 1, 30);
    },

    fetch_markup() {
        return $.get({
            url: '/wp-json/hookturn/v1/newsletter/popup',
            dataType: 'json'
        });
    },

    init_dynamic_component() {
        this.after_document_scroll(() => {
            this.show_popup()
            this.$form = this.$popup.find('.NewsletterPopup__form');
            this.$form.on('submit', (event) => {
                event.preventDefault();
                this.show_loader();
                this.post_request();
            });
            this.listen_for_close();
        });
    },

    // Will call the callback ONCE when the user is down the page.
    after_document_scroll(callback) {
        const scroll_hander = throttle(300, () => {
            let center_screen_scroll_pos = $window.scrollTop() + ($window.height() / 2);
            let half_page_height = $document.height() / 2;
            if (center_screen_scroll_pos >= half_page_height) {
                $window.off('scroll', scroll_hander);
                callback();
            }
        });
        $window.on('scroll', scroll_hander);
    },

    show_popup() {
        this.$popup.toggleClass('translate-y-150');
    },

    show_loader() {
        this.$popup.find('.NewsletterPopup__loader').toggleClass('translate-x-full');
    },

    post_request() {
        // Note that we have no error handling in place here. This could be improved at some
        // point but given it isn't essential, let's not worry for now.
        $.post('/wp-json/hookturn/v1/newsletter/register', this.capture_form_value_hash()).always(() => {
            this.show_confirmation();
            this.set_hide_cookie();
        });
    },

    show_confirmation() {
        this.$popup.find('.NewsletterPopup__confirmation').toggleClass('translate-x-full');
    },

    listen_for_close() {
        this.$popup.find('.NewsletterPopup__close').on('click', () => {
            this.close_popup();
        });
    },

    close_popup() {
        this.$popup.addClass('translate-y-150');
        this.set_hide_cookie();
    },

    capture_form_value_hash() {
        let hash = {};
        $.each(this.$form.serializeArray(), function () {
            hash[this.name] = this.value;
        });
        return hash;
    },
};

export default NewsletterPopup;